import {
  SOURCE_TYPES,
  SourceContextProvider,
} from '@omni/kit/contexts/SourceContext';
import { SafeAreaView, View } from 'react-native';
import { SizeClass, useSizeClass } from '@omni/kit/contexts/SizeClassContext';

import { ChatAuthContextProvider } from '../../src/messaging/context/ChatAuthContext';
import { DOMAIN_GROUPS } from '../../src/search/Constants';
import { IRootProps } from '@omni/kit/contexts/types';
import PropTypes from 'prop-types';
import { Provider } from 'react-redux';
import React from 'react';
import ReactToWebComponent from '@omni/kit/utilities/ReactToWebComponent';
import Search from '../../src/search';
import store from '../../src/messaging/shared/redux/store';
import { useTranslation } from 'react-i18next';

interface IGroupsProps {
  pathPrefix?: string;
}

export default function Groups(props: IGroupsProps & IRootProps): JSX.Element {
  const { sizeClass } = useSizeClass();
  const { t } = useTranslation(['groups']);

  return (
    <View
      style={{
        flex: 1,
        width: '100%',
        alignSelf: 'center',
      }}
    >
      <SafeAreaView />
      <Search
        appKey={props.appKey}
        rootAppKey={props.appKey}
        domains={[DOMAIN_GROUPS]}
        pathPrefix={props.pathPrefix ?? ''}
        headerTitle={t('headerTitle')}
        headerShown={props.headerShown ?? false}
        isNativeNavStackAtRoot={props.isNativeNavStackAtRoot}
        enableLinking={sizeClass !== SizeClass.Small}
      />
    </View>
  );
}

/**
 * Usage:
 * <ss-groups
 *   app-key="CHURCH"
 *   access-token="Bearer eyJh...PMrk"
 *   path-prefix="sunny/"
 * ></ss-groups>
 */
export const GroupsApp = (props: IGroupsProps & IRootProps): JSX.Element => {
  return (
    <Provider store={store}>
      {/* using source 'messaging' to track group finder together with messaging for the time being */}
      <SourceContextProvider source={SOURCE_TYPES.MESSAGING}>
        <ChatAuthContextProvider props={props}>
          <Groups {...props} />
        </ChatAuthContextProvider>
      </SourceContextProvider>
    </Provider>
  );
};

// Required for reactToWebComponent
GroupsApp.propTypes = {
  accessToken: PropTypes.string,
  appKey: PropTypes.string.isRequired,
  pathPrefix: PropTypes.string,
};

export function registerGroupsWC(tagName = 'ss-groups'): void {
  customElements.define(tagName, ReactToWebComponent(GroupsApp));
}
